<ng-container *transloco="let convert;">
  <app-modal [modalId]="modalId + '_' + index">
    @if (isLoading) {
      <div class="loader-container">
        <app-spinner></app-spinner>
      </div>
    }
    @if (isOpen) {
      <div [hidden]="isLoading">
        @if (!waitingResponse && !successfulResponse) {
          @if (checkModalType('ACCEPT')) {
            <app-offer-modals-header [heading]="textAccept" [tenantName]="tenantName">
            </app-offer-modals-header>
          }
          @if (checkModalType('COUNTER')) {
            <app-offer-modals-header [heading]="textCounter" [tenantName]="tenantName">
            </app-offer-modals-header>
          }
          @if (checkModalType('DECLINE')) {
            <app-offer-modals-header [heading]="textDecline" [tenantName]="tenantName">
            </app-offer-modals-header>
          }
          <p class="text-danger fw-bold" [class.d-none]="!errorMessage" aria-atomic="true" aria-live="polite"
            #error>
            @if (errorMessage) {
              {{ convert('vehicles.counterOffer.errorMsgTitle') }}
            }
          </p>
          <div class="modal__content">
            <app-offer-history [vin]="item.vin" [offerHistory]="offerHistory" [bidHistory]="bidHistory">
            </app-offer-history>
            @if (showSpareKey) {
              <!-- Checkbox styling comes from RUIC's .material-checkbox -->
              <div class="material-checkbox spare-key-option">
                <mat-checkbox
                  [id]="'common-action-spare-key-checkbox_' + index"
                  [checked]="spareKeyAvailable && spareKeySelected()"
                  [disabled]="!spareKeyAvailable"
                  [disableRipple]="true"
                  (change)="spareKeySelected.set($event.checked)"
                  data-testid="shared-list-common-action-modal-spare-key-checkbox">
                  <span>
                    {{ textAddSpareKeyFor }}
                    <strong>{{ formatCurrency(platformSpareKeyFee(), false) }}</strong>
                    {{ textSentToBuyingDealership }}
                  </span>
                </mat-checkbox>
              </div>
            }
            <div id="disclosures">
              @if (checkModalType('ACCEPT')) {
                <p
                [innerHTML]="convert('vehicles.acceptOfferModal.msgDescription', {vehicleTitle: vehicleTitle, sellingDisclosureUrl: sellingDisclosureUrl})"></p>
              }
              @if (checkModalType('COUNTER')) {
                <p
                [innerHTML]="convert('vehicles.counterOfferModal.msgDescription', {vehicleTitle: vehicleTitle, sellingDisclosureUrl: sellingDisclosureUrl})"></p>
              }
              @if (checkModalType('DECLINE')) {
                <p
                [innerHTML]="convert('vehicles.declineOfferModal.msgDescription', {vehicleTitle: vehicleTitle})"></p>
              }
            </div>
          </div>
          <form name="makeOfferForm" [formGroup]="form" novalidate>
            <div class="form-group">
              <label class="d-block text-start" for="counter-offer-comment">{{
              convert('vehicles.counterOffer.textComments')}}</label>
              <textarea id="offerListActionModal_counter_offer_comment" class="form-control" rows="3" maxlength="150"
                formControlName="offerComment" (keyup)="replaceInvalidCharacters( $event )" appCharacterCount
                #comment="appCharacterCount">
              </textarea>
              <app-character-count [count]="comment.count$ | async" [maxLength]="150"
                [characterCountTranslate]="characterCountData">
              </app-character-count>
            </div>
            @if (checkModalType('ACCEPT') || checkModalType('COUNTER') || checkModalType('OFFER')) {
              <ng-container *ngTemplateOutlet="financeSourceFeeMessage"></ng-container>
            }
            <div class="form-group service-fee-details">
              @if (!showBuyFeesInOffers()) {
                <label class="d-block text-start">{{ convert('vehicles.counterOffer.labelSeller') }}</label>
                <div class="seller-offer-amount">{{ formattedRootOffer }}</div>
              } @else {
                <app-datalist-item identifier="auction_info_service_fee_text"
                  label="{{ convert('vehicles.counterOffer.labelSeller') }}"
                  value="{{ formattedRootOffer }}">
                </app-datalist-item>
                <app-datalist-item identifier="auction_info_service_fee_text"
                  label="{{ convert('vehicles.counterOffer.fees') }}"
                  value="{{ formatCurrency(bidItemBuyFeeTotal, true) }}">
                  <span>
                    @switch (isMobile) {
                      @case (true) {
                        <span>
                          <app-tooltip [tooltip]="feeDetailsToolTipBody" [showToolTipAsHtml]="true"
                            triggers="click :keydown.escape :keydown.tab" (click)="analyticsInfo('Service Fee Details')"
                            allytmln="Service Fee Details">
                            <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                          </app-tooltip>
                        </span>
                      }
                      @case (false) {
                        <span>
                          <app-tooltip [tooltip]="feeDetailsToolTipBody" [showToolTipAsHtml]="true"
                            triggers="hover :keydown.escape :keydown.tab" (click)="analyticsInfo('Service Fee Details')"
                            allytmln="Service Fee Details">
                            <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                          </app-tooltip>
                        </span>
                      }
                      @default {
                        <span>
                          <app-tooltip [tooltip]="feeDetailsToolTipBody" [showToolTipAsHtml]="true"
                            triggers="hover click :keydown.escape :keydown.tab" (click)="analyticsInfo('Service Fee Details')"
                            allytmln="Service Fee Details">
                            <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                          </app-tooltip>
                        </span>
                      }
                    }
                  </span>
                </app-datalist-item>
              }
              @if (showSpareKey) {
                <app-datalist-item identifier="common_action_spare_key_total_text"
                  data-testid="shared-list-common-action-modal-spare-key-total"
                  [label]="textSpareKeyTotal"
                  value="{{ formatCurrency(spareKeyTotal, false) }}">
                </app-datalist-item>
              }
              <hr>
                <app-datalist-item identifier="auction_info_service_fee_text" [label]="textPurchaseTotal"
                  value="{{ totalPurchasePrice }}">
                </app-datalist-item>
              </div>
              <div class="row">
                <div class="col-md-6">
                  @if (checkModalType('COUNTER')) {
                    <div class="form-group">
                      <label class="d-block text-start text-uppercase" for="counter-offer-amount"
                        id="counter-offer-amount-label">{{
                      convert('vehicles.counterOffer.btnCounter') }}</label>
                      <div class="input-container">
                        <app-currency-input
                          [inputConfig]="inputConfig"
                          [inputForm]="form"
                          [inputId]="'vom_counter_offer_textbox'"
                        ></app-currency-input>
                      </div>
                    </div>
                  }
                </div>
                @if (errorMessage) {
                  <div class="col-md-12 error_message" aria-atomic="true" aria-live="polite">
                    @if (isOfferAmount || isDeclinedOffer || isAcceptOffer) {
                      <p class="text-danger fw-bold" id="counter-offer-amount-error" #error>{{convert('error.' + errorMessage) }}</p>
                    }
                    @if (!isOfferAmount) {
                      <p class="text-danger fw-bold" id="counter-offer-amount-error" #error>{{ errorMessage }}</p>
                    }
                  </div>
                }
              </div>
            </form>
            <div class="d-flex flex-column flex-lg-row lg-justify-content-start action-buttons">
              @if (checkModalType('ACCEPT')) {
                <button class="btn btn-primary" (click)="accept()" type="button"
                  data-track-elem="button" allytmln="acceptBuyAction" id="offerListActionModal_accept_offer_button">
                  {{ convert('vehicles.counterOffer.btnAccept') }}
                </button>
              }
              @if (checkModalType('COUNTER')) {
                <button class="btn btn-primary" (click)="counter()" type="button"
                  data-track-elem="button" allytmln="counterBuyAction" id="offerListActionModal_counter_offer_button">
                  {{ convert('vehicles.counterOffer.btnCounter') }}
                </button>
              }
              @if (checkModalType('DECLINE')) {
                <button [class]="declineButtonClass" (click)="decline()" type="button"
                  data-track-elem="button" allytmln="declineBuyAction" id="offerListActionModal_decline_offer_button">
                  {{ convert('vehicles.counterOffer.btnDecline') }}
                </button>
              }
              <button id="offerListActionModal_cancel_button" class="ms-lg-2 mt-3 mt-lg-0 btn btn-link" type="button"
                (click)="close()" data-track-elem="button" data-track-name="Cancel" data-track-trigger="close">
                <span>{{ convert('common.btnCancel') }}</span>
              </button>
            </div>
            <div class="modal-close-container">
              <button class="modal__close" [attr.aria-label]="convert('common.modalClose')" (click)="close()"
                data-track-elem="icon" data-track-name="Close" data-track-trigger="close" id="do_close_x_button"
                #closeButton>
                <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
              </button>
            </div>
          }
          @if (isSubmittingOffer()) {
            <!-- submitting  offer/counter offer -->
            <app-action-submitting actionText="{{ convert('vehicles.counterOffer.actionTextCounteringOffer') }}">
            </app-action-submitting>
          }
          @if (isSubmittingDecline()) {
            <!-- submitting decline -->
            <app-action-submitting actionText="{{ convert('vehicles.counterOffer.actionTextDecliningOffer') }}">
            </app-action-submitting>
          }
          @if (isSubmittingAccept()) {
            <!-- submitting accept -->
            <app-action-submitting actionText="{{ convert('vehicles.counterOffer.actionTextAcceptingOffer') }}">
            </app-action-submitting>
          }
          <!-- Accepted states:-->
          @if (isCounterAccepted()) {
            <!-- Countered Offer-->
            <app-action-submitted (close)="close()"
              actionText="{{ convert('vehicles.counterOffer.actionTextOfferCountered') }}" [tenantName]="tenantName">
            </app-action-submitted>
          }
          @if (isOfferDeclined()) {
            <!--  Declined Offer-->
            <app-action-submitted (close)="close()"
              actionText="{{ convert('vehicles.counterOffer.actionTextOfferDeclined') }}" [tenantName]="tenantName">
            </app-action-submitted>
          }
          @if (isOfferAccepted()) {
            <!--  Accepted Offer-->
            <app-action-submitted (close)="close()"
              actionText="{{ convert('vehicles.counterOffer.actionTextOfferAccepted') }}" [tenantName]="tenantName">
            </app-action-submitted>
          }
          @if (isError()) {
            <app-action-error (close)="close()" [tenantName]="tenantName" [errorText]="errorText">
            </app-action-error>
          }
        </div>
      }
    </app-modal>

    <ng-template #financeSourceFeeMessage>
      @if (isFinanceSourceFeeIncluded()) {
        <p aria-labelledby="bid-modal-finance-source-fee-text" [innerHTML]="convert('vehicles.bidModal.textFinanceSourceFee',{name: financeSource.financeSourceName, amount: financeSource.feeAmount})"></p>
      }
    </ng-template>
  </ng-container>
